<template>
  <span v-if="isSprintHalted">
    <BaseSubHeading
      color="accent-03"
      darkColor="accent-200"
      size="large"
    >
      Sprint #{{ sprint?.sprint?.sequenceNumber ?? $t("none") }}
    </BaseSubHeading>
  </span>
  <span v-else>
    Sprint #{{ sprint?.sprintSequenceNumber ?? $t("none") }} {{ sprint?.startDate ?? $t("none") }} -
    {{ sprint?.endDate ?? $t("none") }}
    <slot />
  </span>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component"
import { Prop } from "vue-property-decorator"

@Options({
  name: "NotificationSprintHeader",
  components: {}
})
export default class NotificationSprintHeader extends Vue {
  @Prop() readonly sprint

  get isSprintHalted() {
    return !!this.sprint?.haltReasonSummary
  }
}
</script>
